import React from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export default function BackButton({ fallback = "/" }) {
    const navigate = useNavigate();

    const handleGoBack = () => {
        if (window.history.state?.idx > 0) {
            navigate(-1);
        } else {
            navigate(fallback);
        }
    };

    return (
        <Button
            variant="outline-dark"
            className="back-button"
            onClick={handleGoBack}
        >
            ← Quay lại
        </Button>
    );
}